module.exports = __webpack_public_path__ + "img/ring_y_s_1_1@3x.addcd811.png";